import { useSSRData } from 'hooks';
import { getListingData } from 'utils';
import getFirstCorrectData from './utils';

const useListingData = () => {
    const state = useSSRData();
    const listingData = getFirstCorrectData(
        state.listingData,
        getListingData(),
        {},
    );

    const promotedProduct = listingData.promotedProduct || {};

    return {
        listingData,
        promotedProduct,
    };
};

export default useListingData;
